// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H0Z_V","left":"styles_left__3ohGj"};